export const getPrintSettings = ({ event, availableAccount }) => {
  const posSettings =
    event?.pos_settings || availableAccount?.pos_settings || undefined;

  const calculator = posSettings?.calculator ?? true;
  const printSettingEnabled = posSettings?.ticket_delivery === 'print';
  const printReceiptEnabled = posSettings?.receipt_delivery === 'print';
  const printReceiptWithTickets =
    posSettings?.receipt_delivery === 'print_w_tickets';

  return {
    posSettings,
    calculator,
    printSettingEnabled,
    printReceiptEnabled,
    printReceiptWithTickets,
  };
};
